import React, { useEffect, useState, useRef } from 'react';
import * as S from './estilos';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import FundoSombra from '../../Images/FundoSombra.jpg';
import SetaFotos from '../../Images/SetaFotos.png';
import useData from '../../Utils/useData/index';

type eventsType = {
  id_tb_evento_foto: string;
  c_extensao: number;
};

function Eventos() {
  const [eventData, setEventData] = useState<any>([]);
  const [fotos, setFotos] = useState([]);
  const [mostraEvento, setMostraEvento] = useState(false);

  const [load, setLoad] = useState(true);
  const [id, setId] = useState(true);
  const [visible, setVisible] = useState(false);

  const page = useRef(1);
  const path = 'https://gruposaopauloeventos.com.br/expobarrafunda/upload/evento_new';

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  function CarregaDados() {
    useData()
      .getData('/api/evento.php?page=1')
      .then((response: any) => {
        setEventData(response);
        setLoad(false);
      })
      .catch((err) => {
        console.info(err);
      });
  }

  function CarregaMais() {
    page.current = page.current + 1;
    setLoad(true);
    useData()
      .getData('/api/evento.php?page=' + page.current)
      .then((response: any) => {
        setLoad(false);
        setEventData((eventData: any) => [...eventData, ...response]);
      })
      .catch((err) => {
        console.info(err);
      });
  }

  useEffect(() => {
    setTimeout(() => {
      CarregaDados();
    }, 2000);
  }, []);

  return (
    <>
      <div className='Ancora' id='Eventos'></div>
      <S.ForaEventos>
        <S.TextEventos1>
          <span>Eventos</span> Realizados
        </S.TextEventos1>

        <S.ForaItensEventos>
          {eventData.map(
            (
              data: {
                c_titulo: string;
                id_tb_evento: boolean | ((prevState: boolean) => boolean);
                fotos: React.SetStateAction<never[]>;
                c_arquivo: string;
              },
              index: React.Key | null | undefined,
            ) => (
              <S.ItemEvento
                key={index}
                onClick={() => {
                  setId(data.id_tb_evento);
                  setFotos(data.fotos);
                  setVisible(true);
                  setMostraEvento(true);
                }}
                style={{
                  // eslint-disable-next-line quotes
                  backgroundImage: 'url(' + data.c_arquivo + ')',
                }}>
                <S.OutTextEvento className='OutTextEvento'>
                  <S.TextEvento>{data.c_titulo}</S.TextEvento>
                </S.OutTextEvento>
              </S.ItemEvento>
            ),
          )}
        </S.ForaItensEventos>

        <S.ForaMaisEventos
          onClick={() => {
            CarregaMais();
          }}>
          <S.TextMaisEventos>Mostrar Mais Fotos</S.TextMaisEventos>
          <S.ForaImgSetaEventos>
            <S.SetaEventos src={SetaFotos} />
          </S.ForaImgSetaEventos>
        </S.ForaMaisEventos>
      </S.ForaEventos>

      {mostraEvento == true && (
        <S.BgEvento>
          <S.TextXEvento onClick={() => setMostraEvento(false)}>X</S.TextXEvento>
          <S.ForaEvento>
            <Slider className='SliderEvento' {...settings}>
              {fotos.map((data: eventsType, index) => (
                <S.ItemImgEvento key={index}>
                  <S.ImgItemEvento src={`${path}/${id}/${data.id_tb_evento_foto}.${data.c_extensao}`} />

                  <div
                    key={index}
                    style={{
                      color: '#000000',
                    }}></div>
                </S.ItemImgEvento>
              ))}
            </Slider>
          </S.ForaEvento>
        </S.BgEvento>
      )}

      <S.ForaSobraEventos>
        <S.ImagemSobraEventos src={FundoSombra} />
      </S.ForaSobraEventos>
    </>
  );
}

export default Eventos;
